module.exports = __webpack_public_path__ + "static/media/trend-icon-dot.477534a1.svg";